import React, { useState, useRef, useEffect } from "react";
import { useAuth } from '../context/AuthContext';
import { useNavigation } from '../context/NavigationContext';
import { useNavigate, useLocation } from "react-router-dom";
import config from "../config";
import { menuItemPorRota } from "../config/menuItems";

const Header = () => {
  const navigate = useNavigate();
  const { auth, logout, empresa, empresaErro } = useAuth();
  const { currentMenu } = useNavigation();
  const location = useLocation();

  // O nome da tela sai da rota, não do último `updateMenu` executado: página que
  // esquecia de chamá-lo herdava o nome da anterior — o cabeçalho dizia
  // "Portfólio" com Configurações aberta. `currentMenu` continua como reserva
  // para rotas que não estão no menu.
  const telaAtual = menuItemPorRota(location.pathname) || currentMenu;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef();

  const getInitials = (fullName) => {
    if (!fullName) return '';
    const [firstName, lastName] = fullName.trim().split(' ');
    const firstInitial = firstName ? firstName[0].toUpperCase() : '';
    const lastInitial = lastName ? lastName[0].toUpperCase() : '';
    return `${firstInitial}${lastInitial}`;
  };

  // Fechar o dropdown ao clicar fora
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    logout();
  };

  return (
    <header className="h-[50px] mx-4 md:mx-10 mt-10 flex items-center justify-between border-b border-[#dfe4ea] px-2 md:px-4 bg-gray-50">
      {/* Alinhado à Esquerda: primeiro a EMPRESA, depois a tela.
          A empresa mudou de lado: estava à direita, colada no avatar, que é a
          área de "sua conta" — não a de "onde você está". Aqui ela encabeça a
          linha de contexto, porque é ela que determina o significado de tudo o
          que a tela mostra. O nome vai sempre em texto, mesmo com logo no menu:
          logo sozinha é ambígua e não é lida por leitor de tela. */}
      <div className="flex items-center gap-3 min-w-0">
        <div
          className="flex items-center pr-3 border-r border-[#dfe4ea]"
          title={empresa?.nome ? `Empresa: ${empresa.nome}` : "Empresa"}
          data-testid="empresa-atual"
        >
          {empresa ? (
            <span className="text-stone-800 text-sm md:text-base font-semibold truncate max-w-[140px] md:max-w-[240px]">
              {empresa.nome}
            </span>
          ) : empresaErro ? (
            <span className="text-red-600 text-sm md:text-base font-medium">
              Empresa não identificada
            </span>
          ) : (
            <span className="block h-4 w-24 md:w-32 bg-slate-200 rounded animate-pulse" aria-hidden="true" />
          )}
        </div>

        <div className="flex items-center gap-2 text-stone-600 text-sm md:text-base font-medium min-w-0">
          {telaAtual.icon && (
            <img src={telaAtual.icon} alt="" className="w-4 h-4 md:w-5 md:h-5 flex-none" />
          )}
          <span className="truncate">{telaAtual.name}</span>
        </div>
      </div>

      {/* Alinhado à Direita: usuário e conta */}
      <div className="flex items-center gap-3 md:gap-4 relative">
        {/* Nome do Usuário: Esconde em telas muito pequenas */}
        <div className="hidden sm:block text-stone-800 text-sm md:text-base font-medium font-['Inter']">
          {auth.user.name}
        </div>
        {/* Iniciais do Usuário com Dropdown */}
        <div
          className="w-8 h-8 md:w-10 md:h-10 bg-slate-200 rounded-full flex items-center justify-center cursor-pointer relative"
          ref={dropdownRef}
          onClick={() => setDropdownOpen(!dropdownOpen)}
        >
          {auth.user.photoUrl ? (
            <img
              src={config.urlArquivo(auth.user.photoUrl)}
              alt={auth.user.name}
              className="w-full h-full object-cover rounded-full"
            />
          ) : (
            <div className="text-gray-600 text-sm md:text-base font-medium font-['Inter']">
              {getInitials(auth.user.name)}
            </div>
          )}
          {/* Dropdown Menu */}
          {dropdownOpen && (
            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-300 rounded-md shadow-lg z-50">
              <button
                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                onClick={() => {
                  navigate('/usuario/profile');
                  setDropdownOpen(false);
                }}
              >
                Perfil
              </button>
              <button
                className="w-full text-left px-4 py-2 hover:bg-gray-100"
                onClick={() => {
                  handleLogout();
                  setDropdownOpen(false);
                }}
              >
                Sair
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;
